import type { RouteRecordRaw } from 'vue-router'

export const toolsRoutes: RouteRecordRaw = {
  path: '/:lang?/tools',
  props: (route) => ({ lang: route.params.lang || 'en' }),
  component: () => import('@/Tools/layouts/DefaultLayout.vue'),
  children: [
    {
      path: '',
      name: 'tools',
      component: () => import('@/Tools/views/ToolsView.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Tools', child: '_Economic calendar' },
        breadcrumbRoute: 'tools/'
      }
    },
    {
      path: 'economic-calendar/',
      name: 'economic-calendar',
      component: () => import('@/Tools/views/CalendarView.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Tools', child: '_Economic calendar' },
        breadcrumbRoute: 'tools/'
      }
    },
    {
      path: 'markets-holiday-calendar/',
      name: 'markets-holiday-calendar',
      component: () => import('@/Tools/views/HolidayCalendarView.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Tools', child: '_Market holidays' },
        breadcrumbRoute: 'tools/'
      }
    },
    {
      path: 'market-analysis/',
      name: 'market-analysis',
      component: () => import('@/Tools/views/AcuityOverviewView.vue')
    },
    {
      path: 'market-analysis/:slug/',
      name: 'market-analysis-insight-pro',
      component: () => import('@/Tools/views/InsightPro.vue')
    },
    {
      path: 'market-analysis/signals/',
      name: 'market-analysis-insight-pro-signals',
      component: () => import('@/Tools/views/InsightProSignalsView.vue')
    },
    {
      path: 'dividend-calendar/',
      name: 'dividend-calendar',
      component: () => import('@/Tools/views/DividendCalendarView.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Tools', child: '_Dividend calendar' },
        breadcrumbRoute: 'tools/'
      }
    }
  ]
}
